const paper_1_2k25 = {
  questions: {
    1: "1",
    2: "1",
    3: "1",
    4: "1",
    5: "2",
    6: "2",
    7: "2",
    8: "3",
    9: "3",
    10: "3",
    11: "3",
    12: "3",
    13: "3",
    14: "4",
    15: "4",
    16: "4",
    17: "1",
    18: "1",
    19: "1",
    20: "1",
    21: "2",
    22: "2",
    23: "2",
    24: "3",
    25: "3",
    26: "3",
    27: "3",
    28: "3",
    29: "3",
    30: "4",
    31: "4",
    32: "4",
    33: "1",
    34: "1",
    35: "1",
    36: "1",
    37: "2",
    38: "2",
    39: "2",
    40: "3",
    41: "3",
    42: "3",
    43: "3",
    44: "3",
    45: "3",
    46: "4",
    47: "4",
    48: "4",
  },
  sections: {
    1: [1, 17, 33],
    2: [5, 21, 37],
    3: [8, 24, 40],
    4: [14, 30, 46],
  },
};

export default paper_1_2k25;
